<div class="content">
    <ng-content></ng-content>
</div>